// extracted by mini-css-extract-plugin
module.exports = {"mhTextD":"mhTextD_mhTextD__pwfhJ"};